import { ACTIVE_ROLES, isValidActiveRole } from '../../../../util/activeRole';

const HOST_NOTIFICATION_ROLES = new Set(['host', 'provider']);
const CREATIVE_NOTIFICATION_ROLES = new Set(['creative', 'customer']);

const normalizeNotificationRole = role => {
  const normalizedRole = String(role || '')
    .trim()
    .toLowerCase();

  if (isValidActiveRole(normalizedRole)) {
    return normalizedRole;
  }
  if (HOST_NOTIFICATION_ROLES.has(normalizedRole)) {
    return ACTIVE_ROLES.HOST;
  }
  if (CREATIVE_NOTIFICATION_ROLES.has(normalizedRole)) {
    return ACTIVE_ROLES.CREATIVE;
  }

  return null;
};

const getRoleFromTransactionRoute = targetUrl => {
  const path = String(targetUrl || '')
    .trim()
    .toLowerCase();

  if (
    path.startsWith('/sale/') ||
    path === '/dashboard' ||
    path.startsWith('/dashboard?') ||
    path === '/listings' ||
    path.startsWith('/listings?') ||
    path === '/l/new'
  ) {
    return ACTIVE_ROLES.HOST;
  }

  if (path.startsWith('/order/') || path === '/favorites' || path.startsWith('/favorites?')) {
    return ACTIVE_ROLES.CREATIVE;
  }

  return null;
};

export const getNotificationTargetRole = notification => {
  const metadataRole = [
    notification?.targetRole,
    notification?.recipientRole,
    notification?.transactionRole,
  ]
    .map(normalizeNotificationRole)
    .find(Boolean);

  return metadataRole || getRoleFromTransactionRoute(notification?.targetUrl);
};
